import { getRenderStyleProperty } from '../../../../../../CanvasState/Helpers/Style/textBody';

const getAutoFitText = shape => getRenderStyleProperty(shape, shape.get('textBody'), ['autoFitText']);

export default getAutoFitText;
